<script>
import DropDown from '../reUse/DropDown.vue';
import Notification from '../reUse/Notification.vue';
import {config} from "@/config";
export default {
  components: {
    DropDown,
    Notification,
  },
  emits: ['odjava'],

  data() {
    return {
      piloti: [],
      pilotName: '',
      idPilota: '',
      dPilot: '',
      showSkupno: false,
      searchPilot: '',
      //NOTIFICATIONS
      text: '',
      types: '',
      ShowNoti: false,
      praviceJadralno: [],
      urejanje: false,
      urejanje_vse: false,
      brisanje: false,
      brisanje_vse: false,
      userLVL: '',
      izbranMeni: '',
      isLoading: false,
      user: config.FullUser,
    };
  },
  watch: {
    pilotName(star, nov) {
      if (star !== nov) {
        if (this.izbranMeni !== '') { //izpis pravic izvedemo samo, če je že izbran meni
          this.PraviceUporabnika();
        }
      }
    }
  },
  computed: {
    FiltriraniPilot() {
      return this.piloti.filter(pilot => pilot.lvl >= this.user.lvl);
    }
  },

  mounted() {
    this.BeriPilote();
  },

  methods: {
    BeriPilote() {
      axios.get('./api/uporabniki/izpis/', {withCredentials: true}).then((response) => {
        this.piloti = response.data.uporabniki;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri branju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    selectPilot(id) {
      let pilot = this.piloti.find(p => p.id === id);
      if (pilot) {
        // this.pilotName = pilot.ime + ' ' + pilot.priimek;
        this.pilotName = pilot.ime + ' ' + pilot.priimek;
        this.idPilota = pilot.id;
        this.userLVL = pilot.lvl;
        this.dPilot = false;
      }
    },
    OpenPilot() {
      this.dPilot = !this.dPilot;
    },
    PraviceUporabnika() {
      this.urejanje = false;
      this.urejanje_vse = false;
      this.brisanje = false;
      this.brisanje_vse = false;
      var podatki = new URLSearchParams();
      setTimeout(() => {
        podatki.append('uID', this.idPilota);
        podatki.append('menuID', this.izbranMeni);
        axios.post('./api/uporabniki/pravice/izpis/', podatki, {withCredentials: true}).then((response) => {
          this.praviceJadralno = response.data.pravice;
          this.IzpisPravice();
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri branju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        });
      }, 500);
    },
    IzpisPravice() {
      if (this.userLVL < 2) {
        this.urejanje = true;
        this.urejanje_vse = true;
        this.brisanje = true;
        this.brisanje_vse = true;
        return;
      }
      for (var i = 0; i < this.praviceJadralno.length; i++) {
        if (this.praviceJadralno[i].za === 'urejanje') {
          this.urejanje = this.praviceJadralno[i].omogoceno;
        } else if (this.praviceJadralno[i].za === 'urejanje_vse') {
          this.urejanje_vse = this.praviceJadralno[i].omogoceno;
        } else if (this.praviceJadralno[i].za === 'brisanje') {
          this.brisanje = this.praviceJadralno[i].omogoceno;
        } else if (this.praviceJadralno[i].za === 'brisanje_vse') {
          this.brisanje_vse = this.praviceJadralno[i].omogoceno;
        }
      }
    },
    PosodobiPravice() {
      this.isLoading = true;
      if (this.izbranMeni !== '') {
        var podatki = new URLSearchParams();
        podatki.append('id_uporabnika', this.idPilota);
        podatki.append('lvl', this.userLVL);
        axios.post('./api/uporabniki/pravice/nivo/uredi/', podatki, {withCredentials: true}).then((response) => {
          var podatki = new URLSearchParams();
          podatki.append('uID', this.idPilota);
          podatki.append('menu', this.izbranMeni);
          podatki.append('pravice', 'urejanje');
          podatki.append('vrednost', this.urejanje);
          axios.post('./api/uporabniki/pravice/uredi/', podatki, {withCredentials: true}).then((response) => { //urejanje
            var podatki = new URLSearchParams();
            podatki.append('uID', this.idPilota);
            podatki.append('menu', this.izbranMeni);
            podatki.append('pravice', 'urejanje_vse');
            podatki.append('vrednost', this.urejanje_vse);
            axios.post('./api/uporabniki/pravice/uredi/', podatki, {withCredentials: true}).then((response) => { //urejanje_vse
              var podatki = new URLSearchParams();
              podatki.append('uID', this.idPilota);
              podatki.append('menu', this.izbranMeni);
              podatki.append('pravice', 'brisanje');
              podatki.append('vrednost', this.brisanje);
              axios.post('./api/uporabniki/pravice/uredi/', podatki, {withCredentials: true}).then((response) => { //brisanje
                var podatki = new URLSearchParams();
                podatki.append('uID', this.idPilota);
                podatki.append('menu', this.izbranMeni);
                podatki.append('pravice', 'brisanje_vse');
                podatki.append('vrednost', this.brisanje_vse);
                axios.post('./api/uporabniki/pravice/uredi/', podatki, {withCredentials: true}).then((response) => { //brisanje_vse
                  this.text = response.data.sporocilo;
                  this.types = "Uspešno";
                  this.ShowNoti = true;
                  this.BeriPilote();
                  this.isLoading = false;
                }).catch((napaka) => {
                  if (napaka.response.status === 401) {
                    this.$router.push('/Logout');
                  }
                  if (napaka.response.data.napaka !== undefined) {
                    this.text = 'Napaka pri posodabljanju podatkov. ' + napaka.response.data.napaka;
                  } else {
                    this.text = 'Napaka pri posodabljanju podatkov.';
                  }
                  this.types = 'Napaka';
                  this.ShowNoti = true;
                });
              }).catch((napaka) => {
                if (napaka.response.status === 401) {
                  this.$router.push('/Logout');
                }
                if (napaka.response.data.napaka !== undefined) {
                  this.text = 'Napaka pri posodabljanju podatkov. ' + napaka.response.data.napaka;
                } else {
                  this.text = 'Napaka pri posodabljanju podatkov.';
                }
                this.types = 'Napaka';
                this.ShowNoti = true;
              });
            }).catch((napaka) => {
              if (napaka.response.status === 401) {
                this.$router.push('/Logout');
              }
              if (napaka.response.data.napaka !== undefined) {
                this.text = 'Napaka pri posodabljanju podatkov. ' + napaka.response.data.napaka;
              } else {
                this.text = 'Napaka pri posodabljanju podatkov.';
              }
              this.types = 'Napaka';
              this.ShowNoti = true;
            });
          }).catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri posodabljanju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri posodabljanju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          });
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri posodabljanju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri posodabljanju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        });
      } else {
        var podatki = new URLSearchParams();
        podatki.append('id_uporabnika', this.idPilota);
        podatki.append('lvl', this.userLVL);
        axios.post('./api/uporabniki/pravice/nivo/uredi/', podatki, {withCredentials: true}).then((response) => {
          this.text = response.data.sporocilo;
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.BeriPilote();
          this.isLoading = false;
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri posodabljanju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri posodabljanju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        })
      }
    },
  }
}
</script>
<template>
  <!--     <div class="upper-cloud border-bottom-0 rounded-bottom-4 p-2">
        <button class="p-2 btn-back" @click.prevent="$emit('back')"><i class="fas fa-arrow-left fa-2x"></i></button>
        <h4 class="d-flex justify-content-center text-white">pravice uporabnikov</h4>
    </div> -->
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>Nazaj</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">Pravice uporabnikov</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <label class="label-dropdown" for="pilotName">Izberi uporabnika aplikacije <button v-if="pilotName !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="pilotName = ''">Pobriši izbiro</button></label>
    <div class="drop-down-icon text-black" @click.prevent="OpenPilot()">
      <i v-show="!dPilot" class="fas fa-chevron-right"></i>
      <i v-show="dPilot" class="fas fa-chevron-down"></i>
    </div>
    <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="pilotName" @click.prevent="OpenPilot">{{pilotName}}</button>
    <transition name="fade">
      <drop-down @uporabnik="selectPilot" :data="FiltriraniPilot" type="uporabniki" class="drop-down-btn" v-if="dPilot" />
    </transition>
  </div>
  <Transition name="fade" v-if="pilotName !== ''">
    <div class="container p-2">
      <div class="col-12 col-md-6 p-1">
        <div class="container">
          <div class="hr-with-text p-2"><span class='text-danger'>Stopnja uporabnika</span></div>
          <!-- LVL UPORABNIKA -->
          <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
            <div class='text-white p-2'>
              <p class="fs-6 text-podatki">Stopnja uporabnika</p>
              <p class="fs-6 fw-bold">
                <select v-model="userLVL" class="input border-0 rounded-4 p-2 fs-5">
                  <option value='0' v-if="this.user.lvl === 0">Admin</option>
                  <option value='1' v-if="this.user.lvl <= 1">Upravitelj</option>
                  <option value='2'>Inštruktor</option>
                  <option value='3'>Kronometrist</option>
                  <option value='4'>Pilot</option>
                  <option value='5'>Gost</option>
                  <option value='6'>CAMO</option>
                </select>
              </p>
            </div>
          </div>
          <div class="p-1"></div>
          <!-- LVL UPORABNIKA -->
          <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
            <div class='text-white p-2'>
              <p class="fs-6 text-podatki">Izberi meni za urejanje pravic</p>
              <p class="fs-6 fw-bold">
                <select v-model="izbranMeni" class="input border-0 rounded-4 p-2 fs-5" @change.prevent="PraviceUporabnika()">
                  <option value='1'>Jadralna štartna lista</option>
                  <option value='2'>Motorna štartna lista</option>
                </select>
              </p>
            </div>
          </div>
          <div class="p-1"></div>
        </div>
      </div>
    </div>
  </Transition>
  <Transition name="fade" v-if="izbranMeni !== '' && this.pilotName !== ''">
    <div class="container p-2">
      <div class="col-12 col-md-6 p-1">
        <div class="container">
          <div class="hr-with-text p-2"><span class='text-danger'>Pravice izbranega menija</span></div>
          <!-- UREJANJE VSEH -->
          <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
            <div class='text-white p-2'>
              <p class="fs-6 text-podatki">Urejanje lastnih zapisov</p>
              <p class="fs-6 fw-bold">
                <label class='switch col-6'>
                  <input type='checkbox' :disabled="this.userLVL < 2" v-model="urejanje">
                  <span class="slider round" :class="{'disabled': this.userLVL < 2}"></span>
                </label> <br/>
                <span class='text-manjsi text-success' v-if="this.userLVL < 2">Uporabnikova stopnja mu že omogoča to nastavitev, zato spreminjanje ni možno</span>
              </p>
            </div>
          </div>
          <div class="p-1"></div>
          <!-- UREJANJE VSEH -->
          <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
            <div class='text-white p-2'>
              <p class="fs-6 text-podatki">Urejanje vseh zapisov </p>
              <p class="fs-6 fw-bold">
                <label class='switch col-6'>
                  <input type='checkbox' :disabled="this.userLVL < 2" v-model="urejanje_vse">
                  <span class="slider round" :class="{'disabled': this.userLVL < 2}"></span>
                </label> <br/>
                <span class='text-manjsi text-success' v-if="this.userLVL < 2">Uporabnikova stopnja mu že omogoča to nastavitev, zato spreminjanje ni možno</span>
              </p>
            </div>
          </div>
          <div class="p-1"></div>
          <!-- BRISANJE -->
          <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
            <div class='text-white p-2'>
              <p class="fs-6 text-podatki">Brisanje lastnih zapisov </p>
              <p class="fs-6 fw-bold">
                <label class='switch col-6'>
                  <input type='checkbox' :disabled="this.userLVL < 2" v-model="brisanje">
                  <span class="slider round" :class="{'disabled': this.userLVL < 2}"></span>
                </label> <br/>
                <span class='text-manjsi text-success' v-if="this.userLVL < 2">Uporabnikova stopnja mu že omogoča to nastavitev, zato spreminjanje ni možno</span>
              </p>
            </div>
          </div>
          <div class="p-1"></div>
          <!-- BRISANJE VSEH -->
          <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
            <div class='text-white p-2'>
              <p class="fs-6 text-podatki">Brisanje vseh zapisov </p>
              <p class="fs-6 fw-bold">
                <label class='switch col-6'>
                  <input type='checkbox' :disabled="this.userLVL < 2" v-model="brisanje_vse">
                  <span class="slider round" :class="{'disabled': this.userLVL < 2}"></span>
                </label> <br/>
                <span class='text-manjsi text-success' v-if="this.userLVL < 2">Uporabnikova stopnja mu že omogoča to nastavitev, zato spreminjanje ni možno</span>
              </p>
            </div>
          </div>
          <div class="p-1"></div>
        </div>
      </div>
    </div>
  </Transition>
  <div class="container p-2" v-if="pilotName !== ''">
    <button @click.prevent="PosodobiPravice()" class="btn btn-primary rounded-pill btn-add col-12">
      <div v-if="!isLoading">Posodobi</div>
      <div v-else class="spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
  </div>
  <div class="container p-2">
    <!-- OPIS MENIJEV -->
    <div class="hr-with-text p-2"><span class='text-danger'>Opis stopenj</span></div>
    <div class='row'>
      <div class="col-md-6">
        <div class="container p-1">
          <!-- LVL UPORABNIKA -->
          <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
            <div class='text-white p-2'>
              <ul>
                <li> <span class="text-podatki"><strong>Upravitelj:</strong></span>
                  <ol>
                    <li>Štartne liste (vse)</li>
                    <li>Obračuni</li>
                    <li>Šifranti</li>
                    <li>Splošne nastavitve</li>
                    <li>Logi</li>
                    <li>Dnevnik (pilota)</li>
                    <li>Nalogi za let (pregled/potrditev/zavrnitev)</li>
                    <li>Dnevni razpored</li>
                    <li>Pregled površin</li>
                  </ol>
                </li>
                <li> <span class="text-podatki"><strong>Inštruktor:</strong></span>
                  <ol>
                    <li>Štartne liste (vse)</li>
                    <li>Dnevnik (pilota)</li>
                    <li>Nalogi za let (pregled/potrditev/zavrnitev)</li>
                    <li>Dnevni razpored letenja</li>
                    <li>Pregled površin</li>
                  </ol>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="container p-1">
          <!-- LVL UPORABNIKA -->
          <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
            <div class='text-white p-2'>
              <ul>
                <li> <span class="text-podatki"><strong>Kronometrist:</strong></span>
                  <ol>
                    <li>Štartne liste (vse)</li>
                    <li>Dnevni razpored letenja</li>
                    <li>Pregled površin</li>
                    <li>Dnevnik (pilota) (če je motorna licenca)</li>
                    <li>Nalog za let (če je motorna licenca)</li>
                  </ol>
                </li>
                <li> <span class="text-podatki"><strong>Pilot:</strong></span>
                  <ol>
                    <li>Štartne liste (odvisno od licence)</li>
                    <li>Nalog za let</li>
                    <li>Dnevni razpored letenja</li>
                    <li>Pregled površin</li>
                  </ol>
                </li>
                <li> <span class="text-podatki"><strong>Gost:</strong></span>
                  <ol>
                    <li>Pregled površin</li>
                  </ol>
                </li>
                <li>
                  <span class="text-podatki">
                    <strong>CAMO</strong>
                  </span>
                  <ol>
                    <li>Seštevek vseh letov</li>
                    <li>Seštevek skupnih ur</li>
                    <li>Datum in čas izpisa</li>
                    <li>Štartne liste: samo vpogled po dnevih (datumsko) flight time (čas letenja) in št. letov</li>
                  </ol>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
  </Transition>
  <div class='col-12 p-5'></div>
</template>